import { Icon, IconProps } from "..";

export const Ketamine = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" height="60px" width="60px" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9333 4.5V5.56667H17.8667V6.63333H16.8V5.56667H15.7333V4.5H14.6667V8.76667H13.6V7.7H12.5333V6.63333H8.26667V7.7H7.2V8.76667H6.13333V9.83333H5.06667V5.56667H4V9.83334L5.06667 9.83333V14.1H6.13333V19.4333H7.2V20.5H9.33333V19.4333H8.26667V14.1H9.33333V13.0333H10.4V11.9667H11.4667V13.0333H12.5333V14.1H13.6V15.1667H14.6667V19.4333H15.7333V20.5H17.8667V19.4333H16.8V16.2333H17.8667V13.0333H18.9333V10.9H20V4.5H18.9333ZM16.8 8.76667H15.7333V7.7H16.8V8.76667ZM18.9333 8.76667H17.8667V7.7H18.9333V8.76667Z"
          fill="currentColor"
        />
        <path d="M6.13333 4.5H5.06667V5.56667L6.13333 5.56667V4.5Z" fill="currentColor" />
      </>
    </Icon>
  );
};
